import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Restores the expected scroll behaviour that a browser gives you with real
 * multi-page navigation: jump to the top on a route change, or smooth-scroll to
 * an in-page anchor when the URL carries a hash (e.g. `/#consultation`). React
 * Router doesn't do either on its own.
 */
export default function ScrollManager() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1))
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
        return
      }
    }
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
